import { isInApp, getResolution } from './index';
import { getUAInfo } from './ua';

const devices: Array<[string, string, string[]]> = [
    ['a7', '640x1136', ['iPhone 5', 'iPhone 5s']],
    ['a7', '1536x2048', ['iPad Air', 'iPad Mini 2', 'iPad Mini 3']],
    ['a8', '640x1136', ['iPod touch (6th gen)']],
    ['a8', '750x1334', ['iPhone 6']],
    ['a8', '1242x2208', ['iPhone 6 Plus']],
    ['a8', '1536x2048', ['iPad Air 2', 'iPad Mini 4']],
    ['a9', '640x1136', ['iPhone SE']],
    ['a9', '750x1334', ['iPhone 6s']],
    ['a9', '1242x2208', ['iPhone 6s Plus']],
    ['a9x', '1536x2048', ['iPad Pro (1st gen 9.7-inch)']],
    ['a9x', '2048x2732', ['iPad Pro (1st gen 12.9-inch)']],
    ['a10', '750x1334', ['iPhone 7']],
    ['a10', '1242x2208', ['iPhone 7 Plus']],
    ['a10x', '1668x2224', ['iPad Pro (2th gen 10.5-inch)']],
    ['a10x', '2048x2732', ['iPad Pro (2th gen 12.9-inch)']],
    ['a11', '750x1334', ['iPhone 8']],
    ['a11', '1242x2208', ['iPhone 8 Plus']],
    ['a11', '1125x2436', ['iPhone X']],
    ['a12', '828x1792', ['iPhone Xr']],
    ['a12', '1125x2436', ['iPhone Xs']],
    ['a12', '1242x2688', ['iPhone Xs Max']],
    ['a12x', '1668x2388', ['iPad Pro (3rd gen 11-inch)']],
    ['a12x', '2048x2732', ['iPad Pro (3rd gen 12.9-inch)']],
];



const pickDeviceByResolution = () => {
    const resolution = getResolution();
    let perhaps: string[] = [];
    for (const device of devices) {
        if (resolution === device[1]) {
            perhaps = perhaps.concat(device[2]);
        }
    }
    return perhaps.length && perhaps;
}

export const getModel = (() => {
    let model = '';
    return () => {
        if (model) {
            return model;
        }
        try {
            const uaInfo = getUAInfo();
            const inApp = isInApp();
            let model = uaInfo.model  || uaInfo.os.name || 'unknown';
            if (uaInfo.os.name !== 'iOS' || inApp) {
                return model;
            }
            const device = pickDeviceByResolution();
            if (device) {
                return device.join(' or ');
            }
            return model;
        } catch (err) {
            return 'unknown';
        }
    };
})();